import { ReactComponent as DashboardIcon } from "icons/dashboard.svg";
import { ReactComponent as GdnsIcon } from "icons/gdns.svg";
import { ReactComponent as GrnsIcon } from "icons/grns.svg";
import { ReactComponent as UserIcon } from "icons/user.svg";
import { ReactComponent as WarehouseIcon } from "icons/warehouse.svg";
import { ReactComponent as EuroIcon } from "icons/euro.svg";

const getWarehousemanNav = () => {
  const disabled_routes = [
    "/users",
    "/waga",
    "/speditors",
    "/stations",
    "/island-zip-codes",
    "/brand-labels",
    "/settings",
    "/warehouse_stock_stats",
    "/warehouse_location_diffs",
    "/inventorizations",
    "/packer_stats",
  ];

  return nav
    .map(({ items, ...rest }) => ({
      ...rest,
      items: items.filter(({ path }) => !disabled_routes.includes(path)),
    }))
    .filter(({ items }) => items.length > 0);
};

const getManagerNav = () => {
  const disabled_routes = [
    "/users",
    "/waga",
    "/speditors",
    "/stations",
    "/settings",
    "/warehouse_stock_stats",
    "/packer_stats",
  ];

  return nav
    .map(({ items, ...rest }) => ({
      ...rest,
      items: items.filter(({ path }) => !disabled_routes.includes(path)),
    }))
    .filter(({ items }) => items.length > 0);
};

const getPackerNav = () => {
  const enabled_routes = ["/", "/packing"];

  return nav
    .map(({ items, ...rest }) => ({
      ...rest,
      items: items.filter(({ path }) => enabled_routes.includes(path)),
    }))
    .filter(({ items }) => items.length > 0);
};

const getNavByRole = (role) => {
  const warehouseman_nav = getWarehousemanNav();
  const packer_nav = getPackerNav();
  const manager_nav = getManagerNav();

  switch (role) {
    case "admin":
      return nav;
    case "warehouseman":
      return warehouseman_nav;
    case "manager":
      return manager_nav;
    case "packer":
      return packer_nav;
    default:
      return [];
  }
};

const nav = [
  {
    name: "",
    type: "single",
    icon: <DashboardIcon />,
    items: [
      {
        name: "Dashboard",
        path: "/",
      },
    ],
  },
  {
    name: "Wydania",
    type: "group",
    icon: <GdnsIcon />,
    items: [
      {
        name: "Obsługa wydań",
        path: "/packing",
      },
      {
        name: "Sortownia",
        path: "/sorting",
      },
      { name: "Wydania", path: "/gdns" },
      {
        name: "Szybka wysyłka",
        path: "/gdns/fast_shipments",
      },
      { name: "Paki wydań", path: "/packs" },
      {
        name: "Zgłoszone braki",
        path: "/missings",
      },
      {
        name: "Paczki",
        path: "/packages",
      },
      {
        name: "Paczki - statystyki",
        path: "/packages/stats",
      },
      {
        name: "Statystyki błędów",
        path: "/user_errors_stats",
      },
    ],
  },
  {
    name: "Dostawy",
    type: "single",
    icon: <GrnsIcon />,
    items: [{ name: "Dostawy", path: "/grns" }],
  },
  {
    name: "Magazyn",
    type: "group",
    icon: <WarehouseIcon />,
    items: [
      {
        name: "Zadania magazynowe",
        path: "/warehouse_tasks",
      },
      {
        name: "Inwentaryzacje",
        path: "/inventorizations",
      },
      {
        name: "Przesunięcia magazynowe",
        path: "/warehouse_location_diffs",
      },
    ],
  },
  {
    name: "Premie",
    type: "single",
    icon: <EuroIcon />,
    items: [
      {
        name: "Premie",
        path: "/packer_stats",
      },
    ],
  },
  {
    name: "Zarządzanie",
    type: "group",
    icon: <UserIcon />,
    items: [
      {
        name: "Produkty",
        path: "/products",
      },
      {
        name: "Dostawcy",
        path: "/suppliers",
      },
      {
        name: "Magazyny",
        path: "/warehouses",
      },
      {
        name: "Alejki",
        path: "/warehouse_aisles",
      },
      {
        name: "Wózki",
        path: "/carts",
      },
      // {
      //   name: "Spedytorzy",
      //   path: "/speditors",
      // },
      {
        name: "Spedytorzy -cenniki",
        path: "/speditor-prices",
      },
      {
        name: "Stanowiska",
        path: "/stations",
      },
      {
        name: "Użytkownicy",
        path: "/users",
      },
      {
        name: "Etykiety markowe",
        path: "/brand-labels",
      },
      {
        name: "Wyspy - kody pocztowe",
        path: "/island-zip-codes",
      },
      { name: "Wartości magazynów", path: "/warehouse_stock_stats" },
      {
        name: "Ustawienia",
        path: "/settings",
      },
    ],
  },
];

export default getNavByRole;
